import { AppConfig } from "@/config/AppConfig";
import { BEvent } from "@/events/BackgroundEvents";
export class Boot {
    bootup() {
        const tennat = AppConfig.tenantid;
        if (tennat) {
            BEvent.publishTenant(tennat);
        }
    }
}
